export default __webpack_public_path__ + "static/loja-7-7cf067ffc91d86e1af05c94c6e9bfedf.png";